export const RolePermissionConfigFilePath = './.auth-permissions.json';
